export default "__VITE_ASSET__BhXjOu3V__"